import type {VariantProps} from "@gluestack-ui/nativewind-utils";
import React from "react";

import {centerStyle} from "./styles";

type ICenterProps = React.ComponentPropsWithoutRef<"div"> &
    VariantProps<typeof centerStyle> & {testID?: string};

const Center = React.forwardRef<HTMLDivElement, ICenterProps>(
    ({className, testID, ...props}, ref) => {
        return (
            <div
                className={centerStyle({class: className})}
                data-testid={testID}
                {...props}
                ref={ref}
            />
        );
    }
);

Center.displayName = "Center";

export {Center};
